import { B2CPolicy, IEnvironmentVariables } from './IEnvironment';

export const b2cPolicies: B2CPolicy = {
  names: {
    signUpSignIn: 'B2C_1A_Signup_Signin',
    forgotPassword: 'B2C_1A_PasswordReset'
  },
  authorityBaseUrl: 'https://mncportaltraining.b2clogin.com/tfp/mncportaltraining.onmicrosoft.com'
};

export const environment: IEnvironmentVariables = {
  commonDomainEmailNoteReleaseDate: '2025-09-01T00:00:00Z',
  b2cPolicies: b2cPolicies,
  production: true,
  buildNumber: '_BUILDNUMBER_',
  version: '_VERSION_',
  baseUrl: 'https://mnc-trn-web-usermgmt.azurewebsites.net/',
  apiUrl: 'https://mnc-trn-api-homehealth.azurewebsites.net',
  platformApiUrl: 'https://mnc-trn-api-platform.azurewebsites.net',
  registryUrl: `https://mnc-trn-api-platform.azurewebsites.net/api/app-registry`,
  authConfig: {
    config: {
      auth: {
        clientId: 'c855ea59-5da0-4e61-93ad-6dce536c33ae',
        postLogoutRedirectUri: 'https://mnc-trn-web-usermgmt.azurewebsites.net/login',
        redirectUri: 'https://mnc-trn-web-usermgmt.azurewebsites.net/login',
        knownAuthorities: ['mncportaltraining.b2clogin.com'],
        authority: `${b2cPolicies.authorityBaseUrl}/${b2cPolicies.names.signUpSignIn}`,
        navigateToLoginRequestUrl: false,
      },
    },
    angularConfig: {
      consentScopes: [
        'https://mncportaltraining.onmicrosoft.com/api/api.Write',
        'https://mncportaltraining.onmicrosoft.com/api/api.Read',
        'https://mncportaltraining.onmicrosoft.com/api/user_impersonation',
      ],
      protectedResourceMap: [
        [
          'https://mnc-trn-api-homehealth.azurewebsites.net/',
          [
            'https://mncportaltraining.onmicrosoft.com/api/api.Write',
            'https://mncportaltraining.onmicrosoft.com/api/api.Read',
            'https://mncportaltraining.onmicrosoft.com/api/user_impersonation',
          ]
        ],
        [
          'https://mnc-trn-api-platform.azurewebsites.net/',
          [
            'https://mncportaltraining.onmicrosoft.com/api/api.Write',
            'https://mncportaltraining.onmicrosoft.com/api/api.Read',
            'https://mncportaltraining.onmicrosoft.com/api/user_impersonation',
          ]
        ],
      ]
    }
  }
};
